
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import productCar from '@/components/common/cards/product-card'

export default {
  components: {
    VueSlickCarousel,
    productCar,
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      settings: {
        dots: true,
        arrows: true,
        dotsClass: 'slick-dots custom-dot-class',
        focusOnSelect: false,
        infinite: false,
        slidesToShow: 2.2,
        slidesToScroll: 2,
        responsive: [
          {
            breakpoint: 780,
            settings: {
              arrows: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1.3,
              slidesToScroll: 1,
              arrows: false,
            },
          },
        ],
      },
    }
  },
  mounted() {},
}
